var O = Object.defineProperty;
var m = (s, e, t) => e in s ? O(s, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : s[e] = t;
var i = (s, e, t) => (m(s, typeof e != "symbol" ? e + "" : e, t), t);
const l = /* @__PURE__ */ new Map();
function f(s, e, t) {
  const n = l.get(s);
  n && (n.timeout && clearTimeout(n.timeout), n.reject(
    new Error("[Vessel] Same action fired again. Keeping only latest.")
  ), l.delete(s)), l.set(s, e), typeof t == "number" && t > 0 && (e.timeout = setTimeout(() => {
    p(s), e.reject(new Error("[Vessel] Action timed out."));
  }, t));
}
function p(s) {
  const e = l.get(s);
  e && (e.timeout && clearTimeout(e.timeout), l.delete(s));
}
function g(s) {
  return l.get(s);
}
function M(s) {
  return `${s ? `[VESSEL-${s.toUpperCase()}]:` : "[VESSEL]:"}`.trimStart();
}
function u(s = "log", e) {
  const t = M(e == null ? void 0 : e.scope);
  return (...n) => {
    e != null && e.debug && console[s](t, ...n);
  };
}
function b(s) {
  return {
    info: u("info", s),
    warn: u("warn", s),
    error: u("error", s)
  };
}
class c extends Error {
  constructor(e, t) {
    super(`${M(t)} ${e}`), this.name = "VesselError";
  }
}
let R = (s = 21) => crypto.getRandomValues(new Uint8Array(s)).reduce((e, t) => (t &= 63, t < 36 ? e += t.toString(36) : t < 62 ? e += (t - 26).toString(36).toUpperCase() : t > 62 ? e += "-" : e += "_", e), "");
const w = "application/x-opensea-vessel-v1+json";
function I() {
  return `op-${R()}`;
}
function C() {
  return `msg-${R()}`;
}
function H(s) {
  const e = new URL(s);
  return `${e.protocol}//${e.host}`;
}
var r = /* @__PURE__ */ ((s) => (s.Handshake = "handshake", s.HandshakeReply = "handshake-reply", s.Message = "message", s.MessageReply = "message-reply", s.Close = "close", s))(r || {});
class h {
  constructor(e, t) {
    i(this, "type");
    i(this, "id");
    i(this, "from");
    i(this, "operation");
    i(this, "payload");
    this.type = e, this.id = (t == null ? void 0 : t.id) ?? C(), this.from = (t == null ? void 0 : t.from) ?? w, this.operation = (t == null ? void 0 : t.operation) ?? I(), this.payload = t == null ? void 0 : t.payload;
  }
  toObject() {
    return {
      type: this.type,
      id: this.id,
      from: this.from,
      operation: this.operation,
      payload: this.payload
    };
  }
}
function $(s, e = w) {
  if (s && typeof s == "object" && "from" in s && s.from === e && "type" in s && Object.values(r).includes(s.type) && "id" in s && "operation" in s)
    return new h(s.type, {
      id: s.id,
      from: s.from,
      operation: s.operation,
      payload: s.payload
    });
  throw new c("Invalid message.");
}
function E(s, e, t) {
  if (e === "*" || s.origin === e)
    return $(s.data, t ?? w);
}
class v {
  constructor(e) {
    i(this, "log");
    i(this, "parent", window.parent);
    i(this, "subscriptions");
    i(this, "closed", !1);
    i(this, "parentOrigin");
    this.parentOrigin = e.parentOrigin, this.subscriptions = {
      [r.Message]: [],
      [r.Close]: []
    }, this.log = b({ debug: e.debug, scope: "CHILD" }), this.onMessage = this.onMessage.bind(this), window.addEventListener("message", this.onMessage, !1);
  }
  callSubscriptions(e, t) {
    const n = this.sendMessage.bind(this);
    if (e === r.Close) {
      this.close(), this.subscriptions[e].forEach((o) => o(t.payload));
      return;
    }
    this.subscriptions[e].forEach((o) => {
      o(t.payload, (a) => {
        n(
          new h(r.MessageReply, {
            operation: t.operation,
            payload: a
          })
        );
      });
    });
  }
  onMessage(e) {
    try {
      const t = E(e, this.parentOrigin);
      if (!t)
        return;
      switch (t.type) {
        case r.Handshake:
          this.parentOrigin = e.origin, this.sendHandshakeReply(t);
          return;
        case r.Message:
          this.callSubscriptions(r.Message, t);
          return;
        case r.MessageReply:
          this.resolveReply(t);
          return;
      }
    } catch (t) {
      this.log.error("Error parsing message from parent", t);
    }
  }
  sendHandshakeReply(e) {
    this.log.info(`Received handshake from ${this.parentOrigin}`);
    const t = new h(r.HandshakeReply, {
      operation: e.operation
    });
    try {
      this.parent.postMessage(t.toObject(), this.parentOrigin);
    } catch (n) {
      this.log.error("Error sending handshake reply", n);
    }
  }
  resolveReply(e) {
    var t;
    this.log.info(`Received reply for action ${e.operation}`);
    try {
      const n = g(e.operation);
      if (n) {
        this.log.info(`Resolving action ${e.operation}`);
        const { resolve: o, reject: a } = n;
        if (p(e.operation), (t = e.payload) != null && t.error) {
          a(e.payload.error);
          return;
        }
        o(e.payload);
      }
    } catch (n) {
      this.log.error("Error resolving reply", n);
    }
  }
  sendMessage(e) {
    if (!this.parent)
      throw new c("Parent frame not found.");
    if (this.closed)
      throw new c("Cannot send message, frame is closed.");
    this.parent.postMessage(e.toObject(), this.parentOrigin);
  }
  /**
   * Send a message to the parent frame and wait for a reply.
   *
   * @param payload The payload to send to the parent frame
   * @param timeout The timeout in milliseconds to wait for a reply, defaults to 5000
   * @returns A promise that resolves with the reply payload. Rejects if the timeout is reached.
   */
  async send(e, t) {
    return new Promise((n, o) => {
      const a = new h(r.Message, {
        payload: e
      });
      f(a.operation, { resolve: n, reject: o }, t);
      try {
        this.sendMessage(a);
      } catch (d) {
        this.log.error("Error sending message to parent", d), o(d);
      }
    });
  }
  /**
   * Emit a message to the parent frame and don't wait for a reply.
   * @param payload The payload to send to the parent frame
   */
  emit(e) {
    const t = new h(r.Message, {
      payload: e
    });
    this.sendMessage(t);
  }
  on(e, t) {
    return this.subscriptions[e].push(t), () => {
      this.off.call(this, e, t);
    };
  }
  once(e, t) {
    const n = this.on(e, (...o) => {
      n(), t(...o);
    });
  }
  off(e, t) {
    this.subscriptions[e] = this.subscriptions[e].filter((n) => n !== t);
  }
  close() {
    this.closed = !0, window.removeEventListener("message", this.onMessage);
    const e = new h(r.Close);
    this.parent.postMessage(e.toObject(), this.parentOrigin);
  }
}
class k {
  constructor(e) {
    i(this, "parentFrame");
    i(this, "child");
    i(this, "frame");
    i(this, "handshakeOperation");
    i(this, "handshakeInterval");
    i(this, "handshakeIntervalTimeout", 500);
    i(this, "handshakeActionResolverId");
    i(this, "subscriptions");
    i(this, "log");
    i(this, "childOrigin");
    i(this, "childUrl");
    i(this, "connected");
    this.frame = e.frame, this.parentFrame = window, this.child = null, this.childUrl = e.url, this.childOrigin = H(e.url), this.connected = !1, this.handshakeOperation = null, this.handshakeInterval = null, e.handshakeIntervalTimeout && (this.handshakeIntervalTimeout = e.handshakeIntervalTimeout), this.subscriptions = {
      [r.Message]: [],
      [r.Close]: []
    }, this.log = b({ debug: e.debug, scope: "PARENT" }), this.parentFrame.addEventListener(
      "message",
      this.onMessage.bind(this),
      !1
    ), this.handshakeActionResolverId = I();
  }
  startHandshake() {
    if (this.log.info(`Sending handshake to ${this.childUrl}`), this.child = this.frame.contentWindow, !this.child)
      throw new Error("Child frame not found");
    let e = 0;
    const t = () => {
      if (this.log.info("Attempting handshake..."), this.child) {
        e += 1;
        const n = new h(r.Handshake);
        this.handshakeOperation = n.operation, this.sendMessage(n);
      }
    };
    t(), this.handshakeInterval = window.setInterval(() => {
      if (e >= 5) {
        this.log.warn("Handshake failed after 5 attempts. Giving up."), this.handshakeInterval && window.clearInterval(this.handshakeInterval);
        return;
      }
      t();
    }, this.handshakeIntervalTimeout);
  }
  callSubscriptions(e, t) {
    const n = this.sendMessage.bind(this);
    if (e === r.Close) {
      this.close(), this.subscriptions[e].forEach((o) => o(t.payload));
      return;
    }
    this.subscriptions[e].forEach((o) => {
      o(t.payload, (a) => {
        n(
          new h(r.MessageReply, {
            operation: t.operation,
            payload: a
          })
        );
      });
    });
  }
  handleHandshakeReply(e) {
    var a;
    if (this.log.info(`Received handshake reply from ${this.childUrl}`), e.operation !== this.handshakeOperation)
      throw new Error("Handshake reply operation does not match");
    this.handshakeInterval && window.clearInterval(this.handshakeInterval), this.connected = !0;
    const t = g(this.handshakeActionResolverId);
    if (!t)
      throw new c("Handshake resolver not found");
    this.log.info(`Resolving action ${this.handshakeActionResolverId}`);
    const { resolve: n, reject: o } = t;
    if (p(this.handshakeActionResolverId), (a = e.payload) != null && a.error) {
      o(e.payload.error);
      return;
    }
    n(e.payload);
  }
  onMessage(e) {
    try {
      const t = E(e, this.childOrigin);
      if (!t)
        return;
      switch (t.type) {
        case r.HandshakeReply:
          this.handleHandshakeReply(t);
          break;
        case r.Message:
          this.callSubscriptions(r.Message, t);
          break;
        case r.MessageReply:
          this.resolveReply(t);
          break;
        case r.Close:
          this.callSubscriptions(r.Close, t);
          break;
        default:
          this.log.warn(`Unknown message type: ${t.type}`);
      }
    } catch (t) {
      this.log.error("Error handling message", t);
    }
  }
  resolveReply(e) {
    var t;
    this.log.info(`Received reply for action ${e.operation}`);
    try {
      const n = g(e.operation);
      if (n) {
        this.log.info(`Resolving action ${e.operation}`);
        const { resolve: o, reject: a } = n;
        if (p(e.operation), (t = e.payload) != null && t.error) {
          a(e.payload.error);
          return;
        }
        o(e.payload);
      }
    } catch (n) {
      this.log.error("Error resolving reply", n);
    }
  }
  sendMessage(e) {
    if (!this.child)
      throw new c("Child frame not found.");
    if (e.type !== r.Handshake && !this.connected)
      throw new c("Not connected to child frame.");
    this.child.postMessage(e.toObject(), this.childOrigin);
  }
  /**
   * Send a message to the child frame and wait for a reply.
   *
   * @param payload The payload to send to the child frame
   * @param timeout The timeout in milliseconds to wait for a reply, defaults to 5000
   * @returns A promise that resolves with the reply payload. Rejects if the timeout is reached.
   */
  async send(e, t) {
    return new Promise((n, o) => {
      const a = new h(r.Message, {
        payload: e
      });
      f(a.operation, { resolve: n, reject: o }, t);
      try {
        this.sendMessage(a);
      } catch (d) {
        this.log.error("Error sending message to child", d), o(d);
      }
    });
  }
  /**
   * Emit a message to the parent frame and don't wait for a reply.
   * @param payload The payload to send to the parent frame
   */
  emit(e) {
    const t = new h(r.Message, {
      payload: e
    });
    this.sendMessage(t);
  }
  connect({ isFrameLoaded: e = !1 } = {}) {
    return new Promise((t, n) => {
      this.log.info(`Connecting to child iframe ${this.childUrl}`), e ? this.startHandshake() : this.frame.addEventListener("load", this.startHandshake.bind(this)), f(this.handshakeActionResolverId, { resolve: t, reject: n });
    });
  }
  on(e, t) {
    return this.subscriptions[e].push(t), () => {
      this.off.call(this, e, t);
    };
  }
  once(e, t) {
    const n = this.on(e, (...o) => {
      n(), t(...o);
    });
  }
  off(e, t) {
    this.subscriptions[e] = this.subscriptions[e].filter((n) => n !== t);
  }
  close() {
    this.log.info("Closing frames"), this.subscriptions[r.Message] = [], this.subscriptions[r.Close] = [], this.handshakeOperation = null, this.handshakeInterval && window.clearInterval(this.handshakeInterval), p(this.handshakeActionResolverId), this.connected = !1;
  }
}
class y {
  static createParentFrame(e) {
    return new k(e);
  }
  static createChildFrame(e) {
    return new v(e);
  }
}
i(y, "ParentFrame", k), i(y, "ChildFrame", v);
export {
  v as ChildFrame,
  r as MessageType,
  k as ParentFrame,
  y as Vessel
};
